import { render, staticRenderFns } from "./live-header.vue?vue&type=template&id=43a917c7&scoped=true&"
import script from "./live-header.vue?vue&type=script&lang=js&"
export * from "./live-header.vue?vue&type=script&lang=js&"
import style0 from "./live-header.vue?vue&type=style&index=0&id=43a917c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a917c7",
  null
  
)

export default component.exports